import { render, staticRenderFns } from "./expCommunicate .vue?vue&type=template&id=b7d73f2a&scoped=true&"
import script from "./expCommunicate .vue?vue&type=script&lang=js&"
export * from "./expCommunicate .vue?vue&type=script&lang=js&"
import style0 from "./expCommunicate .vue?vue&type=style&index=0&id=b7d73f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d73f2a",
  null
  
)

export default component.exports